export const COMPANYPURCHASELIST_STARTDATE = 'COMPANYTAXDATALIST_STARTDATE';
export const COMPANYPURCHASELIST_ENDDATE = 'COMPANYTAXDATALIST_ENDDATE';
export const COMPANYPURCHASELIST_SELLERCOUNTRYID = 'COMPANYPURCHASELIST_SELLERCOUNTRYID';